module.exports = __webpack_public_path__ + "img/banner1.deb8820c.jpg";